export default {
  postStatus: {
    draft: '草稿',
    published: '发布',
    recycled: "垃圾"
  },
  postType: {
    AR: 'AR资讯',
    HEALTH: '健康资讯',
  },
  sex: {
    male: '男',
    female: '女',
    unknown: '未知'
  },
  tiketOrderStatus: {
    None: { type: 'info', name: '未付款' },
    Payed: { type: 'warning', name: '待充值' },
    Delivered: { type: 'success', name: '已充值' },
    Completed: { type: 'success', name: '已完成' },
    Refunded: { type: 'danger', name: '已退单' },
    Cancel: { type: 'danger', name: '已取消' },
    Fail: { type: 'danger', name: '失败' },
  },

  dsOrderStatus: {
    None: { type: 'info', name: '待付款' },
    Payed: { type: 'warning', name: '充值中' },
    Delivered: { type: 'success', name: '已充值' },
    Completed: { type: 'success', name: '已完成' },
    Refunded: { type: 'danger', name: '已退单' },
    Cancel: { type: 'danger', name: '已取消' },
    Fail: { type: 'danger', name: '失败' },
  },
  mahuaOrderStatus: {
    None: { type: 'info', name: '待付款' },
    Payed: { type: 'warning', name: '出餐中' },
    Delivered: { type: 'success', name: '待取餐' },
    Completed: { type: 'success', name: '已完成' },
    Refunded: { type: 'danger', name: '已退单' },
    Cancel: { type: 'danger', name: '已取消' },
    Fail: { type: 'danger', name: '失败' },
  },
  localOrderStatus: {
    None: { type: 'info', name: '待付款' },
    Payed: { type: 'warning', name: '已支付' },
    Delivered: { type: 'success', name: '已核销' },
    Completed: { type: 'success', name: '已完成' },
    Refunded: { type: 'danger', name: '已退单' },
    Cancel: { type: 'danger', name: '已取消' },
    Fail: { type: 'danger', name: '失败' },
  },
  localWsOrderStatus: {
    None: { type: 'info', name: '待支付' },
    Payed: { type: 'success', name: '已支付' },
    Delivered: { type: 'success', name: '已支付' },
    Completed: { type: 'success', name: '已完成' },
    Cancel: { type: 'danger', name: '已取消' },
    Fail: { type: 'danger', name: '已退单' },
  },
  goodsOrderStatus: {
    None: { type: 'info', name: '待付款' },
    Payed: { type: 'warning', name: '待发货' },
    Delivered: { type: 'success', name: '已发货' },
    Completed: { type: 'success', name: '已完成' },
    Refunded: { type: 'danger', name: '已退单' },
    Cancel: { type: 'danger', name: '已取消' },
    Fail: { type: 'danger', name: '失败' },
  },
  /** 运营商类型 */
  operatorTypes: {
    "": { name: '不限' },
    ChinaMobile: { name: '中国移动' },
    ChinaUnicom: { name: '中国联通' },
    ChinaTelecom: { name: '中国电信' }
  },
  /** 油卡类型 */
  oilTypes: {
    "": { name: '不限' },
    中国石化: { name: '中国石化' },
    中国石油: { name: '中国石油' },
    ChinaTelecom: { name: '中国电信' }
  },
  /** 充值金额*/
  oilRechargeMoney: {
    0: { name: '不限' },
    50000: { name: '500' },
    100000: { name: '1000' },
  },
  /** 充值金额*/
  rechargeMoney: {
    0: { name: '不限' },
    1000: { name: '10' },
    2000: { name: '20' },
    3000: { name: '30' },
    5000: { name: '50' },
    10000: { name: '100' },
    20000: { name: '200' },
    50000: { name: '500' },
  },
  /** 充值方式 */
  rechargeMode: {
    FastCharge: { name: '快充' },
    TrickleCharge: { name: '慢充' },
  }
}